import { render, staticRenderFns } from "./LigaSingle.vue?vue&type=template&id=651d5b7c&scoped=true&"
import script from "./LigaSingle.vue?vue&type=script&lang=js&"
export * from "./LigaSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d5b7c",
  null
  
)

export default component.exports